import { SET_GPSINFO2, checkMobile } from "../../components/AppProvider";
import { useContext } from "react";
import { AppContext } from "./../../components/AppProvider";

export const GetGpsInfo = () => {
  if (checkMobile() == "ANDROID") {
    window.java.getGps();
  } else if (checkMobile() == "IOS") {
    webkit.messageHandlers.rcvFromWeb.postMessage({
      command: "getGps",
      data: "",
    });
  } else {
  }
};

export const SetGpsInfo = (data) => {
  const { dispatch } = useContext(AppContext);
  dispatch({ type: SET_GPSINFO2, data: JSON.parse(data) });
};

// ==== [using ex] ====
// useLayoutEffect(() => {
//   if (phonecfg.phoneOS === "ANDROID") {
//     if (parseInt(phonecfg.version.split(".")[2]) > 81) {
//       GetGpsInfo();
//     } else {
//       socketManager(SocketCommand.GET_GPS_INFO, undefined);
//     }
//   } else if (phonecfg.phoneOS === "IOS") {
//     if (parseInt(phonecfg.version.split(".")[2]) > 35) {
//       GetGpsInfo();
//     } else {
//       socketManager(SocketCommand.GET_GPS_INFO, undefined);
//     }
//   }

//   // GetGpsInfo();
//   window.NativeInterface = {
//     getGpsRtn: (value) => {
//       dispatch({ type: SET_GPSINFO2, data: JSON.parse(value) });
//     },
//   };
// }, []);
